import { useSession } from "../feature-module/configuration/session/hooks/useSession";

export const useActiveSession = () => {
  const { getSessionState } = useSession();
  const { sessions } = getSessionState();
  const activeSession = sessions.find(session => session.status === 'active');

  return activeSession ? { id: activeSession.id, name: activeSession.name } : null;
};
